import type { MenuResponse } from '@/api/modulos.api';

/**
 * Athena es del módulo `inspector`. Si el negocio no lo tiene (Richard), su página
 * llama a /api/asuntos e /inspector/... y responde 404: no se ofrece ni el botón
 * flotante ni la pestaña. Misma fuente que el Sidebar: el menú del servidor.
 * Mientras el menú no llega, no se muestra (evita un parpadeo que luego se esconde).
 */
export function athenaDisponible(datos: MenuResponse | undefined): boolean {
  return Boolean(datos?.rutas.some((r) => r.moduloId === 'inspector'));
}
